/** Marks sign-in pages and URLs carrying credentials so optional tools can skip them. */
export function isPrivateRoute(url = new URL(window.location.href)): boolean {
	const authenticationKeys = ["code", "token", "access_token", "refresh_token", "id_token", "api_key"]
	const hash = new URLSearchParams(url.hash.slice(1))
	return (
		["/login", "/logout", "/auth/callback"].includes(url.pathname.toLowerCase().replace(/\/$/, "")) ||
		authenticationKeys.some(key => url.searchParams.has(key) || hash.has(key))
	)
}

// Fixed app pages shared by the analytics adapters. New routes need a privacy
// review before joining this list; dynamic identifiers are deliberately excluded.
const reviewedPaths = new Set([
	"/",
	"/hunting",
	"/more",
	"/admin",
	"/admin-panel",
	"/permission",
	"/admin/email-templates",
	"/admin/service-tokens",
	"/settings",
	"/my-profile",
	"/activity",
	"/contact-research",
])

/** Returns a reviewed page without query strings or fragments, or no page at all. */
export function getReviewedTrackingPage(url = new URL(window.location.href)): URL | undefined {
	const path = url.pathname.replace(/\/$/, "") || "/"
	if (isPrivateRoute(url) || !reviewedPaths.has(path)) return undefined
	return new URL(path, url.origin)
}
